;delta.qboAuth = function() {
    var

    _$wrapper = null,

    //
    // init 
    //
    init = function () {
        _$wrapper = $('.layout-qbo-auth-response');

        if (_$wrapper.length > 0) {
            submitResponse();
        }
    },

    //
    // calls the connect method.  sourceUrl should be the relative url for the page this is called
    // from, ex: /reportlist or /chatyptc
    // connectUrl is the path to /qboauth/connect?(QSParam)
    //
    connect = function(sourceUrl, connectUrl) {
        //save to session storage
        sessionStorage.setItem("pageParams", delta.pageParams.getPageParams());
        sessionStorage.setItem("destination", sourceUrl);

        //redirect
        window.location = connectUrl;
    },


    //
    // calls the disconnect method.  sourceUrl should be the relative url for the page this is called
    // from, ex: /reportlist or /chatyptc
    //
    disconnect = function(sourceUrl) {
        delta.popup.open({
            type: 'confirm',
            title: 'Disconnect QuickBooks',
            content: 'Are you sure you want to disconnect QuickBooks Online?',
            okButtonText: 'Disconnect',
            okCallback: function () {
                delta.ajax.get(`/qboauth/disconnect?destination=${sourceUrl}`,
                    function (result) {
                        if (result.ok) window.location = result.url;
                    }
                )
            }
        });
    },


    //
    // submit the response to the server, add the pageParams
    //
    submitResponse = function() {
        let url = `/qboauth/ProcessResponse?${window.location.href.split('?')[1]}&${sessionStorage.getItem('pageParams')}&destination=${sessionStorage.getItem('destination')}`;

        //remove it from storage
        sessionStorage.removeItem("pageParams");

        //redirect
        window.location = url;
    };

    $(document).ready(init);

    return {
        connect: connect,
        disconnect: disconnect
    };
}();